import { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { creteUser, eliminarUsuario, getAllUsers, updateOneUser } from '../services/user.service';
import { ProductContext } from './ProductContext';

export const UserContext = createContext();

function UserContextProvider({ children }) {
  const [users, setUsers] = useState([]);
  const { getProductosConQuery } = useContext(ProductContext);

  async function getUsers() {
    const usersResponse = await getAllUsers();
    setUsers(usersResponse);
  }

  async function createUser(values) {
    let exito = await creteUser(values);
    if (exito) await getUsers();
    return exito;
  }

  async function updateUser(values) {
    let exito = await updateOneUser(values);
    getProductosConQuery();
    if (exito) await getUsers();
    return exito;
  }

  async function deleteUser(id) {
    const result = await eliminarUsuario(id);
    if (result) getUsers();
    return result;
  }

  return <UserContext.Provider value={{ users, getUsers, createUser, updateUser, deleteUser }}>{children}</UserContext.Provider>;
}

UserContextProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default UserContextProvider;
